import emptyStateImg from "../assets/empty.png";
import Help from "./Help";
import { helpPagesData } from "../utils/helper";
import { NavLink } from "react-router-dom";

const EmptyState = () => {
  return (
    <div className="empty-state">
      <img src={emptyStateImg} alt="Empty State" className="empty_img" />
      <div className="empty_ttl">No Pages Yet</div>
      <div className="empty_desc">
        Start by creating a new page and add sections like hero, testimonials,
        or FAQs. Manage and customize them easily from here.
      </div>
      <div className="empty_btn-box">
        <Help
          title={helpPagesData.pages.title}
          message={helpPagesData.pages.message}
          items={helpPagesData.pages.items}
        />
        <NavLink to="/pages/add-new" className="btn-black">
          Add New Page
        </NavLink>
      </div>
    </div>
  );
};

export default EmptyState;
